// extracted by mini-css-extract-plugin
export default {"trainAwsPdApplication":"styles_trainAwsPdApplication__HT6Zi","iframeContainer":"styles_iframeContainer__L0T4+"};